<template>
  <el-dialog
    title="选择商品"
    :visible="isVisible"
    :close-on-click-modal="false"
    width="90%"
    append-to-body
    :max-height="'80vh'"
    @close="handleClose"
  >
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <Category
        :value="listQuery.categoryId"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
        :showLevels="false"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="开始日期"
        endPlaceholder="结束日期"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" @click="resetFilter">重置</el-button>
    </div>

    <el-table
      ref="tableRef"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @expand-change="handleExpandChange"
    >
      <el-table-column type="expand" width="50">
        <template slot-scope="props">
          <el-table
            :key="`child-table-${props.row.id}-${refreshKey}`"
            v-if="props.row.children && props.row.children.length > 0"
            :data="props.row.children"
            size="small"
            border
            style="width: 100%"
          >
            <el-table-column align="center" width="55">
              <template slot-scope="scope">
                <el-checkbox
                  :checked="selectedRows.some(item => item.id === scope.row.id)"
                  :disabled="isSpecDisabled(scope.row, props.row)"
                  @change="handleSpecChange(scope.row, props.row, $event)"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="id" label="规格ID" width="95"></el-table-column>
            <el-table-column label="规格名称" align="left" prop="combNames"></el-table-column>
            <el-table-column label="供货价" align="center" prop="supplyPrice"></el-table-column>
            <el-table-column label="价格" align="center" prop="price"></el-table-column>
            <el-table-column label="类型" align="center" prop="combTypes"></el-table-column>
            <el-table-column label="库存" align="center" prop="stock"></el-table-column>
            <el-table-column align="center" prop="ctdate" label="创建时间">
              <template slot-scope="scope">
                <i class="el-icon-time" />
                <span>{{ formatApiDate(scope.row.ctdate) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" width="55">
        <template slot-scope="scope">
          <el-checkbox
            v-if="multiple"
            :value="isGoodsSelected(scope.row.id)"
            :indeterminate="isGoodsIndeterminate(scope.row.id)"
            @change="toggleGoods(scope.row, $event)"
          />
          <el-radio v-else v-model="selectedGoodsId" :label="scope.row.id" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="商户名称" align="center" prop="mchName" width="100"></el-table-column>
      <el-table-column
        label="店铺名称"
        align="center"
        prop="shopName"
        width="100"
      ></el-table-column>
      <el-table-column label="商品名称" align="left" prop="name" width="300"></el-table-column>
      <el-table-column label="原价" align="center" prop="adPrice"></el-table-column>
      <el-table-column label="供货价" align="center" prop="supplyPrice"></el-table-column>
      <el-table-column label="毛利率" align="center" prop="grossMargin">
        <template slot-scope="scope">
          <span>{{ scope.row.grossMargin }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="规格现价" align="center" prop="supplyPrice">
        <template slot-scope="scope">
          <span>{{ scope.row.minPrice }}</span>
          <span v-if="scope.row.maxPrice">~{{ scope.row.maxPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="限购数量" align="center" prop="buyLimit"></el-table-column>
      <el-table-column label="主图地址" align="center" prop="mainGraph" width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.mainGraph"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(PRODUCT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column
        label="类目名称"
        align="center"
        prop="caterotyName"
        width="200"
      ></el-table-column>
      <el-table-column label="是否特供" align="center" prop="tag">
        <template slot-scope="scope">
          {{ scope.row.tag ? "特供商品" : "普通商品" }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag style="color: #ffffff" :color="getValue(PRODUCT_STATUS_CSS, scope.row.status)">{{
            getValue(PRODUCT_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { PRODUCT_STATUS_CSS } from "@/utils/enumUtileCss";
import { getValue, PRODUCT_STATUS, PRODUCT_TYPE } from "@/utils/enumUtile";
import { getGoodsList, getGoodsEditDetail } from "@/api/product";
import { formatApiDate } from "@/utils/utils";
import Category from "@/views/components/category.vue";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  name: "SelectProductModal",
  components: { DataPicker, Category },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedSpecs: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      list: [],
      total: 0,
      listLoading: false,
      selectedGoodsId: null,
      selectedRows: [],
      refreshKey: 0,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        categoryId: null,
        createStartTime: null,
        createEndTime: null
      }
    };
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    PRODUCT_STATUS() {
      return PRODUCT_STATUS;
    },
    PRODUCT_STATUS_CSS() {
      return PRODUCT_STATUS_CSS;
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(val) {
        this.isVisible = val;
        if (val) {
          await this.getList();
          await this.initSelectedRows();
        }
      }
    },
    selectedGoodsId(val) {
      if (this.multiple) return;
      const table = this.$refs.tableRef;
      if (val) {
        // 切换商品时，保留所有属于父组件已选列表（selectedSpecs）中的规格，并且加上当前选定商品的新规格
        const isFromParent = item =>
          this.selectedSpecs &&
          this.selectedSpecs.some(spec => spec.specsId === item.id || spec.id === item.id);
        const isOfNewProduct = item => item.goodsId === val;

        const currentSelected = this.selectedRows.filter(
          item => isFromParent(item) || isOfNewProduct(item)
        );

        // 尝试恢复该商品的父级规格（防止切换回来时缺失）
        const fromParent = (this.selectedSpecs || [])
          .filter(spec => spec.goodsId === val)
          .map(spec => ({
            id: spec.specsId,
            specsId: spec.specsId,
            goodsId: spec.goodsId,
            combNames: spec.specsName || spec.combNames,
            price: spec.price,
            stock: spec.stock,
            combTypes: spec.combTypes,
            supplyPrice: spec.supplyPrice,
            ctdate: spec.ctdate
          }));

        const merged = [...currentSelected];
        fromParent.forEach(p => {
          if (!merged.some(m => m.id === p.id)) {
            merged.push(p);
          }
        });
        this.selectedRows = merged;

        const row = this.list.find(item => item.id === val);
        if (row) {
          this.expandRow(row);
          this.$nextTick(() => {
            if (table && table.toggleRowExpansion) {
              this.list.forEach(item => {
                table.toggleRowExpansion(item, item.id === val);
              });
            }
          });
        }
      } else {
        // 如果选中商品 ID 变成 null，则只保留属于父组件已选列表（selectedSpecs）中的规格
        const isFromParent = item =>
          this.selectedSpecs &&
          this.selectedSpecs.some(spec => spec.specsId === item.id || spec.id === item.id);
        this.selectedRows = this.selectedRows.filter(isFromParent);
        if (table && table.toggleRowExpansion) {
          this.list.forEach(row => {
            table.toggleRowExpansion(row, false);
          });
        }
      }
    }
  },
  methods: {
    getValue,
    getCategoryValueFunc(type, resultArr) {
      if (type === "queryCategory") {
        this.listQuery.categoryId = resultArr;
      }
    },
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      }
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        keyword: null,
        categoryId: null,
        createStartTime: null,
        createEndTime: null
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    async getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
        deleted: 0,
        status: 2
      };
      if (form.categoryId && form.categoryId.length !== 0) {
        params.categoryId = form.categoryId[form.categoryId.length - 1];
      }
      try {
        const response = await getGoodsList(params);
        this.list = response.data.entitys.map(item => ({
          ...item,
          hasChildren: true,
          children: []
        }));
        this.total = response.data.totalCount;
      } finally {
        this.listLoading = false;
      }
    },
    async expandRow(row) {
      if (row.children && row.children.length === 0) {
        const loading = this.$loading({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          const response = await getGoodsEditDetail({ id: row.id });
          if (response.bizcode == 100) {
            const combs = response.data.combs || [];
            row.children = combs.map(comb => ({
              id: comb.id,
              combNames: comb.combNames,
              combTypes: comb.combTypes,
              stock: comb.stock,
              price: comb.price,
              supplyPrice: comb.supplyPrice,
              ctdate: comb.ctdate
            }));
          }
        } catch (error) {
          this.$message.error("获取规格信息失败");
        } finally {
          loading.close();
        }
      }
    },
    handleExpandChange(row, expanded) {
      if (expanded) {
        this.expandRow(row);
        if (this.multiple) return;
        const table = this.$refs.tableRef;
        if (table && table.toggleRowExpansion) {
          this.list.forEach(item => {
            if (item.id !== row.id) {
              table.toggleRowExpansion(item, false);
            }
          });
        }
      }
    },
    isSpecDisabled(specRow, parentRow) {
      // 1. 如果该规格在父组件已选规格列表里（第一次已选规格），始终保持置灰禁用（默认勾选且不能在弹窗取消）
      if (this.selectedSpecs && this.selectedSpecs.some(spec => spec.specsId === specRow.id)) {
        return true;
      }
      return false;
    },
    handleSpecChange(row, parentRow, event) {
      console.log(row, parentRow, event);
      const checked = event;
      const index = this.selectedRows.findIndex(item => item.id === row.id);
      if (checked && index === -1) {
        // 勾选新规格时，自动切换当前商品 ID 到该商品
        if (!this.multiple && this.selectedGoodsId !== parentRow.id) {
          this.selectedGoodsId = parentRow.id;
        }
        this.selectedRows.push({
          ...row,
          goodsId: parentRow.id,
          goodsName: parentRow.name,
          mainGraph: parentRow.mainGraph
        });
      } else if (!checked && index > -1) {
        this.selectedRows.splice(index, 1);
        if (this.multiple) return;
        // 如果取消勾选后，当前 active 产品的规格清空了，自动将当前商品 ID 回弹设置为列表中第一个仍然存在的规格对应的商品 ID
        const activeProductSpecsLeft = this.selectedRows.some(
          item => item.goodsId === this.selectedGoodsId
        );
        if (!activeProductSpecsLeft) {
          if (this.selectedRows.length > 0) {
            this.selectedGoodsId = this.selectedRows[0].goodsId;
          } else {
            this.selectedGoodsId = null;
          }
        }
      }
    },
    isGoodsSelected(goodsId) {
      const row = this.list.find(item => item.id === goodsId);
      const children = row && row.children ? row.children : [];
      return (
        children.length > 0 &&
        children.every(spec => this.selectedRows.some(item => item.id === spec.id))
      );
    },
    isGoodsIndeterminate(goodsId) {
      const row = this.list.find(item => item.id === goodsId);
      const children = row && row.children ? row.children : [];
      if (!children.length) return this.selectedRows.some(item => item.goodsId === goodsId);
      const count = children.filter(spec => this.selectedRows.some(item => item.id === spec.id))
        .length;
      return count > 0 && count < children.length;
    },
    async toggleGoods(row, checked) {
      if (checked) {
        await this.expandRow(row);
        (row.children || []).forEach(spec => {
          if (!this.selectedRows.some(item => item.id === spec.id)) {
            this.selectedRows.push({
              ...spec,
              goodsId: row.id,
              goodsName: row.name,
              mainGraph: row.mainGraph
            });
          }
        });
        this.$nextTick(() => {
          const table = this.$refs.tableRef;
          if (table && table.toggleRowExpansion) table.toggleRowExpansion(row, true);
        });
      } else {
        this.selectedRows = this.selectedRows.filter(item => item.goodsId !== row.id);
      }
      this.refreshKey++;
    },
    async initSelectedRows() {
      if (this.selectedSpecs && this.selectedSpecs.length > 0) {
        const newSelectedRows = this.selectedSpecs.map(spec => ({
          id: spec.specsId,
          specsId: spec.specsId,
          goodsId: spec.goodsId,
          combNames: spec.specsName || spec.combNames,
          price: spec.price,
          stock: spec.stock,
          combTypes: spec.combTypes,
          supplyPrice: spec.supplyPrice,
          ctdate: spec.ctdate
        }));
        if (this.multiple) {
          this.selectedRows = newSelectedRows;
          this.selectedGoodsId = null;
          return;
        }
        if (newSelectedRows.length > 0) {
          this.selectedGoodsId = newSelectedRows[0].goodsId;
          await this.$nextTick();
          const table = this.$refs.tableRef;
          if (table && table.toggleRowExpansion) {
            const goodsId = newSelectedRows[0].goodsId;
            const row = this.list.find(item => item.id === goodsId);
            if (row) {
              table.toggleRowExpansion(row, true);
              await this.expandRow(row);
              await this.$nextTick();
              this.selectedRows = [...newSelectedRows];
              this.refreshKey++;
            }
          }
        }
      } else {
        this.selectedRows = [];
        this.selectedGoodsId = null;
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      console.log(this.selectedRows);
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择商品规格");
        return;
      }

      console.log("确认选择的商品规格:", this.selectedRows);
      if (this.selectedRows.length > 0) {
        this.$emit("confirm", this.selectedRows);
        this.$emit("update:visible", false);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.filter-container {
  margin-bottom: 20px;
  display: flex;
}

.filter-item {
  margin-right: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

:deep(.el-dialog) {
  max-height: 80vh !important;
  display: flex;
  flex-direction: column;
}

:deep(.el-dialog__body) {
  flex: 1;
  overflow-y: auto;
  max-height: calc(80vh - 140px);
}

:deep(.el-dialog__header),
:deep(.el-dialog__footer) {
  flex-shrink: 0;
}

:deep(.el-radio__label) {
  display: none;
}
</style>
